import React, { createContext, useContext, useState, useCallback } from "react";
import { t } from "@/i18n/content";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("ayl_lang") || "en");
  const toggle = useCallback((next) => {
    const value = next || (localStorage.getItem("ayl_lang") === "es" ? "en" : "es");
    localStorage.setItem("ayl_lang", value);
    setLang(value);
  }, []);
  const value = { lang, setLang: toggle, tr: t[lang] };
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
